class QuickSearch extends HTMLElement {
	constructor() {
		super();

        this.quickSearch = this;
        this.headerInput = document.querySelector('input[name="q"]');
        this.headerSearchIcon = document.querySelector('[data-open-search-popup]');
        this.searchResults = this.quickSearch.getElementsByClassName('quickSearchResultsContent')[0];
        this.searchResultsWidget = this.quickSearch.getElementsByClassName('quickSearchResultsWidget')[0];

        this.debouncedOnBeforeFocus = debounce((event) => {
            this.doBeforeQuickSearch();
        }, 100);

        this.debouncedOnFocus = debounce((event) => {
            this.doQuickSearch();
        }, 200);

        this.headerInput.addEventListener('focus', this.debouncedOnBeforeFocus.bind(this));
        this.headerInput.addEventListener('input', this.debouncedOnFocus.bind(this));

        if(this.headerSearchIcon){
            this.headerSearchIcon.addEventListener('click', this.debouncedOnBeforeFocus.bind(this));
        }

        if(window.innerWidth <= 1024){
            if(document.querySelector('[data-search-mobile]')){
                document.querySelectorAll('[data-search-mobile]').forEach((button) => {
                    button.addEventListener('click', this.doBeforeQuickSearch.bind(this));
                });
            }
        }
	}

    doBeforeQuickSearch(){
        this.renderQuickSearchFromBlock();
    }

    doQuickSearch(){
        if (this.headerInput.value.trim() === '') {
            this.searchResults.classList.remove('is-show');
            this.searchResults.classList.add('is-hidden');
            this.searchResultsWidget.classList.remove('is-hidden');
            this.searchResultsWidget.classList.add('is-show');

            return; 
        } else {
            if (this.headerInput.value.length > 2){
                this.quickSearch.classList.add('is-loading');

                var keyword = this.headerInput.value,
                    url = `/search?view=ajax_quick_search&q=${keyword}*&type=product`;

                this.renderQuickSearchFromFetch(url, keyword);
            }
        }
    }

    renderQuickSearchFromBlock(){
        if(!this.searchResultsWidget.classList.contains('ajax-loaded')){
            const block = this.searchResultsWidget.querySelector('.quickSearchProduct');

            let url = block.getAttribute('data-collection'),
                limit = this.quickSearch.getAttribute('data-limit'),
                layout = 'grid',
                imageRatio = this.quickSearch.getAttribute('data-image-ratio'),
                ratio = this.quickSearch.getAttribute('data-ratio'),
                action = true,
                sectionId = 'list-result-block';

            if(url != null && url != undefined) {
                $.ajax({
                    type: 'GET',
                    url: window.routes.root + '/collections/' + url,
                    cache: false,
                    data: {
                        view: 'ajax_product_card_search',
                        constraint: `limit=${limit}+layout=${layout}+sectionId=${sectionId}+imageRatio=${imageRatio}+action=${action}+portraitAspectRatio=${ratio}`
                    },
                    beforeSend: () => {
                        block.closest('.quickSearchResultsWidget').classList.add('ajax-loaded');
                    },
                    success: (data) => {
                        if (url != '') {
                            block.querySelector('.products-grid').innerHTML = data;
                        }
                    },
                    complete: () => {
                        if(window.product_swatch_style == 'slider'){
                            var productList = block.querySelectorAll('.product');

                            productList.forEach((element) => {
                                var product = $(element),
                                    productSwatch = product.find('.card-swatch--slider');
                                
                                if(productSwatch.length > 0){
                                    var swatchGrid = productSwatch.find('.swatch');

                                    if(swatchGrid.length > 0){
                                        if(!swatchGrid.hasClass('slick-initialized')){
                                            Shopify.ProductSwatchs.showSwatchSlider({
                                                slider: swatchGrid,
                                                onComplete: null
                                            });
                                        }
                                    }
                                }
                            });
                        }

                        if(window.compare.show){
                            Shopify.ProductCompare.setLocalStorageProductForCompare();
                        }

                        if(window.wishlist.show){
                            Shopify.ProductWishlist.setLocalStorageProductForWishlist();
                        }

                        if ((window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                            let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                        }
                    }
                });
            } else{
                this.searchResultsWidget.classList.add('ajax-loaded');

                if ((window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                    let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                    Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                }
            }
        }
    }
   
    renderQuickSearchFromFetch(url, keyword){
        let limit = this.quickSearch.getAttribute('data-limit'),
            imageRatio = this.quickSearch.getAttribute('data-image-ratio'),
            ratio = this.quickSearch.getAttribute('data-ratio'),
            layout = 'grid',
            action = true,
            sectionId = 'list-result-search';

        fetch(url)
        .then(response => response.json())
        .then((responseText) => {
            const products = responseText.results;

            var count = responseText.results_count,
                searchQuery;

            if(window.search == 'product'){
                searchQuery = `/search?q=${keyword}&type=product&options%5Bprefix%5D=last`;
            } else {
                searchQuery = responseText.url;
            }

            if(products.length > 0){
                this.searchResults.querySelector('.productEmpty').style.display = 'none';

                var list = []; 

                products.forEach(product => {
                    list.push(product.handle);
                });

                var quickSearch = this.quickSearch,
                    searchResults = this.searchResults,
                    searchResultsWidget = this.searchResultsWidget;

                $.ajax({
                    type: 'GET',
                    url: window.routes.collection_all,
                    cache: false,
                    data: {
                        view: 'ajax_product_card_search_2',
                        constraint: `limit=${limit}+layout=${layout}+sectionId=${sectionId}+imageRatio=${imageRatio}+action=${action}+portraitAspectRatio=${ratio}+list_handle=` + encodeURIComponent(list)
                    },
                    success: (data) => {
                        searchResults.querySelector('.productGrid').innerHTML = data;
                        searchResults.querySelector('.productViewAll').style.display = 'block';
                        searchResults.querySelector('.button-view-all').setAttribute('href', searchQuery);
                        searchResults.querySelector('.button-view-all').innerText = count;
                    },
                    complete: () => {
                        quickSearch.classList.remove('is-loading');
                        searchResultsWidget.classList.remove('is-show');
                        searchResultsWidget.classList.add('is-hidden');
                        searchResults.classList.remove('is-hidden');
                        searchResults.classList.add('is-show');

                        if(window.product_swatch_style == 'slider'){
                            var productList = searchResults.querySelectorAll('.product');

                            productList.forEach((element) => {
                                var product = $(element),
                                    productSwatch = product.find('.card-swatch--slider');
                                
                                if(productSwatch.length > 0){
                                    var swatchGrid = productSwatch.find('.swatch');

                                    if(swatchGrid.length > 0){
                                        if(!swatchGrid.hasClass('slick-initialized')){
                                            Shopify.ProductSwatchs.showSwatchSlider({
                                                slider: swatchGrid,
                                                onComplete: null
                                            });
                                        }
                                    }
                                }
                            });
                        }

                        if(window.compare.show){
                            Shopify.ProductCompare.setLocalStorageProductForCompare();
                        }

                        if(window.wishlist.show){
                            Shopify.ProductWishlist.setLocalStorageProductForWishlist();
                        }
                        
                        if ((window.show_multiple_currencies && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                            let currencyCode = document.getElementById('currencies')?.querySelector('.active')?.getAttribute('data-currency');

                            Currency.convertAll(window.shop_currency, currencyCode, 'span.money', 'money_format');
                        }
                    }
                });
            } else {
                this.searchResults.querySelector('.productGrid').innerHTML = '';
                this.searchResults.querySelector('.productViewAll').style.display = 'none';
                this.searchResults.querySelector('.productEmpty').style.display = 'block';
                this.searchResults.querySelector('.keyword').innerHTML = `<strong>${keyword}.</strong>`;
                this.searchResults.querySelector('.link').setAttribute('href', searchQuery);
                this.quickSearch.classList.remove('is-loading');
                this.searchResultsWidget.classList.remove('is-show');
                this.searchResultsWidget.classList.add('is-hidden');
                this.searchResults.classList.remove('is-hidden');
                this.searchResults.classList.add('is-show');
            }
        });
    }
}

customElements.define('quick-search', QuickSearch);